const Style = {

  user: 'absolute top-1/2 -translate-y-2/4 right-2 sm:right-4 lg:right-12 z-10',
  name: 'float-right opacity-50 text-xs font-normal',

}

export default Style;
